// extracted by mini-css-extract-plugin
export default {"recos":"T--z","productCardOverride":"U--z","rowHasBadge":"V--z"};